import {
  CreateQuoteInput,
  Currency,
  TaxInclusionType,
  TaxType,
  WorkOrdersFieldsFragment,
} from "@/gql/graphql";

export function getQuoteInitialFieldsFromWorkOrder(
  workOrder: WorkOrdersFieldsFragment,
): Partial<CreateQuoteInput> {
  const taxType =
    workOrder.currency === Currency.Aud
      ? workOrder.supplier.tax_type
      : TaxType.NoGst;

  const taxInclusionType =
    taxType === TaxType.NoGst
      ? TaxInclusionType.NoTax
      : TaxInclusionType.Exclusive;

  const departureAddress = [
    workOrder.departureAddress.formatted_address_line_1,
    workOrder.departureAddress.formatted_address_line_2,
  ]
    .filter(Boolean)
    .join(", ");

  const deliveryAddress = [
    workOrder.deliveryAddress.formatted_address_line_1,
    workOrder.deliveryAddress.formatted_address_line_2,
  ]
    .filter(Boolean)
    .join(", ");

  return {
    currency: workOrder.currency,
    payee: {
      connect: workOrder.supplier.billingEntity?.id,
    },
    tax_inclusion_type: taxInclusionType,
    additional_notations:
      "The quoted price is fixed and includes all costs associated with the relocation, including driver fees, fuel, and applicable allowances. Additional charges will only apply where delays, breakdowns, access issues, or other unforeseen circumstances outside of our control result in additional time or expenses being incurred to complete the relocation.\n\nThe vehicle will be delivered with the same fuel level as recorded at the time of collection.",
    lineItems: {
      upsert: [
        {
          quantity: 1,
          description: `Professional driver from ${departureAddress} to ${deliveryAddress}`,
          unit_amount: null!,
          tax_type: taxType,
        },
      ],
    },
    workOrders: {
      connect: [
        {
          id: workOrder.id,
          is_current_quote: true,
        },
      ],
    },
  };
}
